import { createApp, configureCompat } from "vue";
import App from "./App.vue";
import router from "./router";

import { ClerkAuthPlugin } from "./auth/clerkAuth";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faLink,
  faUser,
  faPowerOff,
  faQrcode,
  faChartLine,
  faChartArea,
  faClock,
  faSignal,
  faMobileAlt,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import store from "./store";

function cleanupStaleAppCaches() {
  if (typeof window === "undefined") return;

  const cleanupKey = "tc-stale-app-cache-cleanup-v1";
  try {
    if (window.localStorage && window.localStorage.getItem(cleanupKey) === "done") {
      return;
    }
  } catch (error) {
    // Ignore storage access errors; cache cleanup is a best-effort safety net.
  }

  const tasks = [];
  if ("serviceWorker" in navigator) {
    tasks.push(
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    );
  }

  if ("caches" in window) {
    tasks.push(
      window.caches.keys()
        .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
    );
  }

  Promise.allSettled(tasks).finally(() => {
    try {
      if (window.localStorage) {
        window.localStorage.setItem(cleanupKey, "done");
      }
    } catch (error) {
      // Nothing to persist if localStorage is unavailable.
    }
  });
}

cleanupStaleAppCaches();

if (typeof window !== "undefined") {
  window.__tc_store = store;
}

configureCompat({ MODE: 2 });

// Install Clerk auth plugin (replaces QRAuthPlugin)


library.add(
  faLink,
  faUser,
  faPowerOff,
  faQrcode,
  faChartLine,
  faChartArea,
  faClock,
  faSignal,
  faMobileAlt,
  faCheckCircle
);
const application = createApp(App);
application.use(store);
application.use(ClerkAuthPlugin);
application.component('font-awesome-icon', FontAwesomeIcon);
application.use(router);
const app = application.mount('#app');

// Initialise Clerk after Vue is mounted
app.$clerk.init().then(() => {

  // Expose Clerk instance globally for non-Vue services (e.g. fyers_service.js)
  window.__vue_clerk = app.$clerk;

  // init() completes the authenticated subscription check before route guards
  // decide whether pricing is needed. Reuse that result instead of racing it.
  const data = app.$clerk.subscriptionDetails;
  if (data && data.active) {
    store.dispatch("activateSubscription", {
      plan: data.plan, expiresAt: data.expiresAt,
      internationalCharts: data.internationalCharts,
      indianMarketData: data.indianMarketData,
    });
  }
});
